import React, { useEffect, useState } from "react";
import "./ModalSteps.scss";
import Cart from "./Cart";
import VehicleSelect from "./VehicleSelect";
import WorkshopCard from "./WorkshopCard";
import { Route, Routes, useNavigate } from "react-router-dom";

interface IPROPS {
    checkoutServices: any;
    setStoreVehicleInfo: any;
    storeVehicleInfo: any;
    onClose: any;
    setWorkshopId: any;
    workshopId: any;
    storedGeoLoaction: any;
    setLiftingSlot: any;
    setIsCheckoutClicked: any;
    setCurrentStep: any;
    currentStep: any;
    serviceRecord:any
    homeApiData:any
    setWorkshopData:any
    workshopData:any
}

const ModalSteps: React.FC<IPROPS> = ({
    currentStep,
    setCurrentStep,
    checkoutServices,
    setStoreVehicleInfo,
    storeVehicleInfo,
    onClose,
    setIsCheckoutClicked,
    setLiftingSlot,
    storedGeoLoaction,
    workshopId,
    setWorkshopId,
    serviceRecord,
    homeApiData,
    setWorkshopData,
    workshopData
}) => {
    const [selectedSubServices, setSelectedSubServices] = useState([]);
    const [servicesWithSelections, setServicesWithSelections] = useState([]);
    const [confimrButtonClicked, setConfirmButtonClicked] = useState(false)
    const [selectedServiceNames, setSelectedServiceNames] = useState([]);
    const [selectedSubServiceNames, setSelectedSubServiceNames] = useState([]);
        const [slotClicked, setSlotClicked] = useState(false);

         const navigate = useNavigate();


return (
  <div className={slotClicked ?  "summary-modal-container" : "modal-container-2"} 
  style={{position: 'relative',     marginTop: window.innerWidth < 800 ? "130px" : "170px",
 padding: "15px", marginLeft: window.innerWidth < 800 ? "10px" : "30px", marginRight: window.innerWidth < 800 ? "10px" : "30px", justifyContent: "center"}}>
    {/* <button className="modal-close-btn" onClick={onClose} aria-label="Close Modal">
      &times;
    </button> */}


    {/* Show only on step 1 or 2 */}
          <Routes>

                 <Route path="select" element={
          <VehicleSelect
              storeVehicleInfo={storeVehicleInfo}
            setStoreVehicleInfo={setStoreVehicleInfo}
            onClose={onClose}
            setCurrentStep={setCurrentStep}
            // currentStep={currentStep}
            // setCurrentStep={() => navigate("/vehicle/service")}
            currentStep={1}
          />
        } />

  <Route path="service" element={
          <Cart
            setCurrentStep={() => navigate("/vehicle/service")}
            // currentStep={2}
            checkoutServices={checkoutServices}
            setSelectedSubServices={setSelectedSubServices}
            selectedSubServices={selectedSubServices}
            setServicesWithSelections={setServicesWithSelections}
            servicesWithSelections={servicesWithSelections}
            // setCurrentStep={setCurrentStep}
            setConfirmButtonClicked={setConfirmButtonClicked}
          />
        } />


       <Route path="workshop" element={
          <WorkshopCard
            setCurrentStep={() => navigate("/vehicle/workshop")}
            currentStep={3}
                    setWorkshopId={setWorkshopId}
                    setWorkshopData={setWorkshopData}
                    workshopData={workshopData}
        workshopId={workshopId}
        storedGeoLoaction={storedGeoLoaction}
        setStoreVehicleInfo={setStoreVehicleInfo}
        storeVehicleInfo={storeVehicleInfo}
        setLiftingSlot={setLiftingSlot}
        setIsCheckoutClicked={setIsCheckoutClicked}
        // setCurrentStep={setCurrentStep}
        // currentStep={currentStep}
        selectedSubServices={selectedSubServices}
        servicesWithSelections={servicesWithSelections}
        confimrButtonClicked={confimrButtonClicked}
        selectedServiceNames={selectedServiceNames}
        selectedSubServiceNames={selectedSubServiceNames}
        onClose={onClose}
        serviceRecord={serviceRecord}
        setSlotClicked={setSlotClicked}
        slotClicked={slotClicked}
        homeApiData={homeApiData}
          />
        } />



    {/* {currentStep !== 3 && (
      <>
        <div className={`step step-one ${currentStep === 1 ? "active" : ""}`}>
          <VehicleSelect
            storeVehicleInfo={storeVehicleInfo}
            setStoreVehicleInfo={setStoreVehicleInfo}
            onClose={onClose}
            setCurrentStep={setCurrentStep}
            currentStep={currentStep}
          />
        </div>

        <div className={`step step-two ${currentStep === 2 ? "active" : ""}`}>
          <Cart
            handleRemoveFromCart={handleRemoveFromCart}
            checkoutServices={checkoutServices}
            setSelectedSubServices={setSelectedSubServices}
            selectedSubServices={selectedSubServices}
            setServicesWithSelections={setServicesWithSelections}
            servicesWithSelections={servicesWithSelections}
            setCurrentStep={setCurrentStep}
            setConfirmButtonClicked={setConfirmButtonClicked}
          />
        </div>
      </>
    )}


    <div
      className={`step step-three ${currentStep === 3 ? "active full-width" : ""}`}
    >
      <WorkshopCard
        setWorkshopId={setWorkshopId}
        workshopId={workshopId}
        storedGeoLoaction={storedGeoLoaction}
        setStoreVehicleInfo={setStoreVehicleInfo}
        storeVehicleInfo={storeVehicleInfo}
        setLiftingSlot={setLiftingSlot}
        setIsCheckoutClicked={setIsCheckoutClicked}
        setCurrentStep={setCurrentStep}
        currentStep={currentStep}
        selectedSubServices={selectedSubServices}
        servicesWithSelections={servicesWithSelections}
        confimrButtonClicked={confimrButtonClicked}
        selectedServiceNames={selectedServiceNames}
        selectedSubServiceNames={selectedSubServiceNames}
        onClose={onClose}
        serviceRecord={serviceRecord}
        setSlotClicked={setSlotClicked}
        slotClicked={slotClicked}
        homeApiData={homeApiData}

      />
    </div> */}

    </Routes>
  </div>
);


};

export default ModalSteps;
